import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { showcaseEndpoint } from 'Services/Apis/clients';

export const LoadShowCaseList = createAsyncThunk(
  'showcaseList/Load',
  async (payload, { getState }) => {
    const state = getState();
    const { oidc } = state;
    const response = await showcaseEndpoint(oidc.user).get(
      `Showcase/ShowAll/${payload.identifier}?PageNumber=${payload.pageNumber}&PageSize=${payload.pageSize}`
    );
    return response.data;
  },
);

const initialState = {
  isLoading: true,
  error: true,
  list: [],
  totalCount: 0,
  totalPages: 0
};

const ShowcaseListSlice = createSlice({
  name: 'showcaseListSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(LoadShowCaseList.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(LoadShowCaseList.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.list = payload.products.data;
        state.totalCount = payload.products.totalCount;
        state.totalPages = payload.products.totalPages;
        state.error = false;
      })
      .addCase(LoadShowCaseList.rejected, (state) => {
        state.isLoading = false;
        state.list = [];
        state.error = true;
      })
  },
});

export default ShowcaseListSlice.reducer;
